import { Component, OnInit } from '@angular/core';
import { ApiClient } from '../common/api-client.service';

@Component({
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintFundsComponent implements OnInit {
  date: Date = new Date();
  ledger: any = {};

  constructor(
    private apiClient: ApiClient
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(l => {
      this.ledger = l;
      setTimeout(() => window.print(), 500);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/funds/print.component.ts